var _ellipse, _circle, _ellipse2, _ellipse3, _circle2, _path, _g, _g2, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapMerch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 52,
    viewBox: "0 0 36 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0856,
    cy: 25.9998,
    rx: 17.0856,
    ry: 21.5428,
    fill: "#CCA2F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0854,
    cy: 3.71427,
    r: 3.71427,
    fill: "#CCA2F8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0857,
    cy: 4.8285,
    rx: 5.19998,
    ry: 2.59999,
    fill: "#CCA2F8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0857,
    cy: 47.1713,
    rx: 5.19998,
    ry: 2.59999,
    fill: "#CCA2F8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0854,
    cy: 48.2856,
    r: 3.71427,
    fill: "#CCA2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47077 25.9999C3.47077 20.9709 5.02056 16.4367 7.50281 13.1706C9.98478 9.9048 13.3773 7.92859 17.085 7.92859C20.7927 7.92859 24.1852 9.9048 26.6672 13.1706C29.1494 16.4367 30.6992 20.9709 30.6992 25.9999C30.6992 31.029 29.1494 35.5632 26.6672 38.8293C24.1852 42.0951 20.7927 44.0713 17.085 44.0713C13.3773 44.0713 9.98478 42.0951 7.50281 38.8293C5.02056 35.5632 3.47077 31.029 3.47077 25.9999Z",
    fill: "url(#paint0_linear_1182_22278)",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_1182_22278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 13.3701C22.8945 13.3701 23.4684 17.6949 25.0379 19.2643C26.6073 20.8337 30.932 21.4076 30.932 21.4076C30.932 21.4076 26.6073 21.9815 25.0379 23.551C23.4684 25.1204 22.8945 29.4451 22.8945 29.4451C22.8945 29.4451 22.3755 25.1752 20.7512 23.551C19.1269 21.9267 14.857 21.4076 14.857 21.4076C14.857 21.4076 19.1818 20.8337 20.7512 19.2643C22.3206 17.6949 22.8945 13.3701 22.8945 13.3701Z",
    fill: "#FBF2C3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_1182_22278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.791 11.8848C14.791 11.8848 15.1046 14.2476 15.962 15.1051C16.8195 15.9625 19.1823 16.2761 19.1823 16.2761C19.1823 16.2761 16.8195 16.5896 15.962 17.4471C15.1046 18.3046 14.791 20.6674 14.791 20.6674C14.791 20.6674 14.5074 18.3345 13.62 17.4471C12.7326 16.5597 10.3997 16.2761 10.3997 16.2761C10.3997 16.2761 12.7625 15.9625 13.62 15.1051C14.4775 14.2476 14.791 11.8848 14.791 11.8848Z",
    fill: "#FBF2C3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 13.3701C22.8945 13.3701 23.4684 17.6949 25.0379 19.2643C26.6073 20.8337 30.932 21.4076 30.932 21.4076C30.932 21.4076 26.6073 21.9815 25.0379 23.551C23.4684 25.1204 22.8945 29.4451 22.8945 29.4451C22.8945 29.4451 22.3755 25.1752 20.7512 23.551C19.1269 21.9267 14.857 21.4076 14.857 21.4076C14.857 21.4076 19.1818 20.8337 20.7512 19.2643C22.3206 17.6949 22.8945 13.3701 22.8945 13.3701Z",
    fill: "#FBF2C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.79 11.8848C14.79 11.8848 15.1035 14.247 15.9608 15.1042C16.818 15.9615 19.1802 16.275 19.1802 16.275C19.1802 16.275 16.818 16.5884 15.9608 17.4457C15.1035 18.3029 14.79 20.6652 14.79 20.6652C14.79 20.6652 14.5065 18.3329 13.6193 17.4457C12.7321 16.5585 10.3998 16.275 10.3998 16.275C10.3998 16.275 12.7621 15.9615 13.6193 15.1042C14.4766 14.247 14.79 11.8848 14.79 11.8848Z",
    fill: "#FBF2C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_1182_22278",
    x: 9.85742,
    y: 8.37012,
    width: 26.0742,
    height: 29.0752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1182_22278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1182_22278",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_1182_22278"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_1182_22278",
    x: 5.39941,
    y: 6.88477,
    width: 18.7832,
    height: 21.7822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1182_22278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1182_22278",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_1182_22278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1182_22278",
    x1: 17.085,
    y1: 44.5713,
    x2: 17.085,
    y2: 7.42859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapMerch);
export default __webpack_public_path__ + "static/media/roadmap_merch.63529766eb7a6d235f90c266cc0c4cdb.svg";
export { ForwardRef as ReactComponent };